<template>
    <div>
        <div class="content">
            <header>
                <div class="banner">
                    <van-row>
                        <van-col span="6" @click="back"><img class="back-icon"
                                                             :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                        </van-col>
                        <van-col span="12">
                            <div class="banner-title">{{ $t('dailyActive.title') }}</div>
                        </van-col>
                        <van-col span="6" @click="toActiveTarget">
                            <img class="right-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/10set.svg`)">
                        </van-col>
                    </van-row>
                </div>
            </header>
            <van-tabs v-model="activeType"
                      @change="changeType"
                      title-active-color="var(--text-color-1)"
                      title-inactive-color="var(--text-color-3)"
                      line-height="2"
                      color="var(--text-color-1)"
            >
                <van-tab :title="$t('dailyActive.tab0')"></van-tab>
                <van-tab :title="$t('dailyActive.tab1')"></van-tab>
                <van-tab :title="$t('dailyActive.tab2')" v-if="showSportStrength"></van-tab>
            </van-tabs>
            <div class="time-box">
                <div v-if="showDay" class="time-item" :class="{'time-active': activeTime === 3}" @click="changeTimeType(3, $t('dailyActive.time3'))">{{ $t('dailyActive.time3') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 2}" @click="changeTimeType(2, $t('dailyActive.time2'))">{{ $t('dailyActive.time2') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{ time }}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
                <div class="chart-unit" v-if="chartNone == 0&&activeType == 0">{{ $t('dailyActive.unit0') }}</div>
                <div class="chart-unit-cal" v-if="chartNone == 0&&activeType == 1">{{ $t('dailyActive.unit1') }}</div>
                <div class="chart-unit-cal" v-if="chartNone == 0&&activeType == 2">{{ $t('dailyActive.unit2') }}</div>
            </div>
            <div id="chart-box"></div>
        </div>
        <div class="math-box" v-if="activeTime !== 3">
            <van-row>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-text">{{ $t('dailyActive.all') }}</div>
                        <div class="math-num" v-if="activeType==0">{{
                                mathData.sum ?
                                    format(parseInt(mathData.sum)) :
                                    '--'
                            }}
                        </div>
                        <div class="math-num" v-if="activeType==1">{{
                                mathData.sum ?
                                    format(parseInt(mathData.sum / 1000))
                                    : '--'
                            }}
                        </div>
                        <div class="math-num" v-if="activeType==2">{{
                                mathData.sum ?
                                    format(parseInt(mathData.sum / 60))
                                    : '--'
                            }}
                        </div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-text">{{ $t('dailyActive.math0') }}</div>
                        <div class="math-num" v-if="activeType==0">{{
                                mathData.maxData ? format(mathData.maxData) :
                                    '--'
                            }}
                        </div>
                        <div class="math-num" v-if="activeType==1">{{
                                mathData.maxData ?
                                    format(parseInt(mathData.maxData / 1000))
                                    : '--'
                            }}
                        </div>
                        <div class="math-num" v-if="activeType==2">{{
                                mathData.maxData ?
                                    format(parseInt(mathData.maxData / 60))
                                    : '--'
                            }}
                        </div>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="math-item">
                        <div class="math-text">{{ activeTime == 2 ? $t('dailyActive.monthAvg') : $t('dailyActive.math1') }}</div>
                        <div class="math-num" v-if="activeType==0">{{
                                mathData.avgData ? format(mathData.avgData) :
                                    '--'
                            }}
                        </div>
                        <div class="math-num" v-if="activeType==1">{{
                                mathData.avgData ?
                                    format(parseInt(mathData.avgData / 1000))
                                    : '--'
                            }}
                        </div>
                        <div class="math-num" v-if="activeType==2">{{
                                mathData.avgData ?
                                    format(parseInt(mathData.avgData / 60))
                                    : '--'
                            }}
                        </div>
                    </div>
                </van-col>
            </van-row>
            <div class="target-desc" v-if="mathData.sum > 0 && activeType == 1">{{ $t('dailyActive.calTCal0') }}<span
                v-if="bigFood.num > 0">{{ 100 * bigFood.num + 'g ' + bigFood[$i18n.locale] }}</span><span
                v-if="showAnd">{{ $t('dailyActive.and') }}</span><span
                v-if="smallFood != 0"> 100g {{ smallFood[$i18n.locale] }}</span>{{ $t('dailyActive.stepToDC2') }}
            </div>
            <div class="compare-box" v-if="currentData > 0 && activeType == 0">
                <div class="compare-desc-box">{{ $t('dailyActive.stepToDC0') }}{{
                        stepLaps
                    }}{{ $t('dailyActive.stepToDC1') }}<span
                        v-if="bigFood.num > 0">{{ 100 * bigFood.num + 'g ' + bigFood[$i18n.locale] }}</span><span
                        v-if="showAnd">{{ $t('dailyActive.and') }}</span><span
                        v-if="smallFood != 0"> 100g {{ smallFood[$i18n.locale] }}</span>{{ $t('dailyActive.stepToDC2') }}
                </div>
                <div class="compare-title-distance">
                    {{ $t('dailyActive.distance') }}
                </div>
                <div class="compare-distance-line"><span class="compare-num">{{
                        stepDistance
                    }}</span>{{ $t('dailyActive.distanceUnit') }}
                </div>
                <div class="compare-title-cal">
                    {{ $t('dailyActive.cal') }}
                </div>
                <div class="compare-cal-line"><span class="compare-num">{{
                        format(stepCal)
                    }}</span>{{ $t('dailyActive.calUnit') }}
                </div>
            </div>
            <div class="separate"></div>
        </div>
        <div class="reach-card-box" v-if="activeTime !== 3">
            <img class="reach-img" v-if="activeType == 0" :src="require(`@/assets/theme/${theme}/status/01dailyActive/07target.svg`)">
            <img class="reach-img" v-if="activeType == 1" :src="require(`@/assets/theme/${theme}/status/01dailyActive/08target.svg`)">
            <img class="reach-img" v-if="activeType == 2" :src="require(`@/assets/theme/${theme}/status/01dailyActive/09target.svg`)">
            <div class="reach-card-text">{{ $t('dailyActive.weekReach') }}</div>
            <div class="reach-line reach-card-line">
                <div class="reach-progress" v-if="activeType == 0">
                    <van-progress :percentage="targetDay/allDay*100" :stroke-width="10*ratio" track-color="var(--bg-color-1)"
                                  color="var(--chart-color-8)"/>
                </div>
                <div class="reach-progress" v-if="activeType == 1">
                    <van-progress :percentage="targetDay/allDay*100" :stroke-width="10*ratio" track-color="var(--bg-color-1)"
                                  color="var(--chart-color-3)"/>
                </div>
                <div class="reach-progress" v-if="activeType == 2">
                    <van-progress :percentage="targetDay/allDay*100" :stroke-width="10*ratio" track-color="var(--bg-color-1)"
                                  color="var(--chart-color-1)"/>
                </div>
                <div class="reach-num"><span class="reach-num-text">{{ targetDay }}</span> /{{ allDay }}</div>
            </div>
        </div>
        <div class="card" v-if="activeTime === 3">
            <div class="card-box">
                <div class="target-line">
                    <span class="current-step">{{ format(this.currentData) }}</span><span
                    class="target-step"> /{{ format(this.targetData) }} <span
                    v-if="activeType == 0">{{ $t('dailyActive.unit0') }}</span><span
                    v-if="activeType == 1">{{ $t('dailyActive.unit1') }}</span><span
                    v-if="activeType == 2">{{ $t('dailyActive.unit2') }}</span></span>
                </div>
                <div class="percent" v-if="activeType == 0">
                    <van-progress :percentage="completRate * 100" :stroke-width="10 * ratio"
                                  track-color="var(--chart-color-84)"
                                  color="var(--chart-color-8)"/>
                    <img class="percent-img" :style="{'left': targetImgLeft + 'px'}"
                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/07target.svg`)">
                </div>
                <div class="percent" v-if="activeType == 1">
                    <van-progress :percentage="completRate * 100" :stroke-width="10 * ratio"
                                  track-color="var(--chart-color-4)"
                                  color="var(--chart-color-3)"/>
                    <img class="percent-img" :style="{'left': targetImgLeft + 'px'}"
                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/08target.svg`)">
                </div>
                <div class="percent" v-if="activeType == 2">
                    <van-progress :percentage="completRate * 100" :stroke-width="10 * ratio"
                                  track-color="var(--chart-color-2)"
                                  color="var(--chart-color-1)"/>
                    <img class="percent-img" :style="{'left': targetImgLeft + 'px'}"
                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/09target.svg`)">
                </div>
                <div class="target-desc" v-if="completRate < 1">{{
                        $t('dailyActive.targetDesc0')
                    }}{{ format(targetData - currentData) }}<span
                        v-if="activeType == 0">{{ $t('dailyActive.targetDesc1') }}</span><span
                        v-if="activeType == 1">{{ $t('dailyActive.targetDesc2') }}</span><span
                    v-if="activeType == 2">{{ $t('dailyActive.targetDesc3') }}</span></div>
                <div class="target-desc" v-if="completRate == 1">{{ $t('dailyActive.over') }}</div>
                <div class="compare-box" v-if="currentData > 0 && activeType == 0">
                    <div class="compare-desc-box">{{ $t('dailyActive.stepToDC0') }}{{
                            stepLaps
                        }}{{ $t('dailyActive.stepToDC1') }}<span
                            v-if="bigFood.num > 0">{{ 100 * bigFood.num + 'g ' + bigFood[$i18n.locale] }}</span><span
                            v-if="showAnd">{{ $t('dailyActive.and') }}</span><span
                            v-if="smallFood != 0"> 100g {{ smallFood[$i18n.locale] }}</span>{{
                            $t('dailyActive.stepToDC2')
                        }}
                    </div>
                    <div class="compare-title-distance">
                        {{ $t('dailyActive.distance') }}
                    </div>
                    <div class="compare-distance-line"><span class="compare-num">{{
                            stepDistance
                        }}</span>{{ $t('dailyActive.distanceUnit') }}
                    </div>
                    <div class="compare-title-cal">
                        {{ $t('dailyActive.cal') }}
                    </div>
                    <div class="compare-cal-line"><span class="compare-num">{{
                            format(stepCal)
                        }}</span>{{ $t('dailyActive.calUnit') }}
                    </div>
                </div>
                <div class="target-desc" v-if="currentData > 0 && activeType == 1">{{ $t('dailyActive.calTCal0') }}<span
                    v-if="bigFood.num > 0">{{ 100 * bigFood.num + 'g ' + bigFood[$i18n.locale] }}</span><span
                    v-if="showAnd">{{ $t('dailyActive.and') }}</span><span
                    v-if="smallFood != 0"> 100g {{ smallFood[$i18n.locale] }}</span>{{ $t('dailyActive.stepToDC2') }}
                </div>
                <div class="separate"></div>
            </div>
        </div>
        <div class="card">
            <div class="card-title-line">
                <div class="card-title">{{ $t('dailyActive.abstract') }}
                </div>
                <div class="target-set" v-if="showAbstract" @click="toAbstract">{{ $t('dailyActive.more') }}<img class="to-img"
                                                                                                                 :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                </div>
            </div>
            <div class="card-box daily-avg" v-if="showAbstract">
                <div class="ratio-title" :class="{'ratio-title-step' : activeType == 0, 'ratio-title-cal' : activeType == 1, 'ratio-title-strength' : activeType == 2}">{{ $t('dailyActive.weekDay') }}</div>
                <div class="target-desc" v-if="activeType == 0">{{ $t('dailyActive.monthDayDesc0') }}{{
                        format(monthAvgStepData)
                    }}<span v-if="symbol!=2">{{ $t('dailyActive.monthDayDesc1') }}<span
                        v-if="symbol==0">{{ $t('dailyActive.weekDayAdd') }}</span><span
                        v-if="symbol==1">{{ $t('dailyActive.weekDayReduce') }}</span>{{
                            format(Math.abs(monthAvgStepData - lastMonthAvgStepData))
                    }}{{ $t('dailyActive.monthDayDesc2') }}</span><span
                        v-if="symbol==2">{{ $t('dailyActive.monthDayDesc3') }}</span>
                </div>
                <div class="target-desc" v-if="activeType == 1">{{ $t('dailyActive.monthCalDayDesc0') }}{{
                        format(monthAvgCalData)
                    }}{{ $t('dailyActive.monthCalDayDesc1') }}<span v-if="symbol!=2"><span
                        v-if="symbol==0">{{ $t('dailyActive.weekDayAdd') }}</span><span
                        v-if="symbol==1">{{ $t('dailyActive.weekDayReduce') }}</span>{{
                            format(Math.abs(monthAvgCalData - lastMonthAvgCalData))
                    }}{{ $t('dailyActive.monthCalDayDesc2') }}</span><span
                        v-if="symbol==2">{{ $t('dailyActive.monthCalDayDesc3') }}</span>
                </div>
                <div class="target-desc" v-if="activeType == 2">{{ $t('dailyActive.monthSportStrengthDesc0') }}{{
                        format(monthAvgSportStrengthData)
                    }}<span v-if="symbol!=2">{{ $t('dailyActive.monthSportStrengthDesc1') }}<span
                        v-if="symbol==0">{{ $t('dailyActive.weekDayAdd') }}</span><span
                        v-if="symbol==1">{{ $t('dailyActive.weekDayReduce') }}</span>{{
                            format(Math.abs(monthAvgSportStrengthData - lastMonthAvgSportStrengthData))
                        }}{{ $t('dailyActive.monthSportStrengthDesc2') }}</span><span
                        v-if="symbol==2">{{ $t('dailyActive.monthSportStrengthDesc3') }}</span>
                </div>
                <div class="month-num" v-if="activeType == 0">{{ format(monthAvgStepData) }}</div>
                <div class="month-num" v-if="activeType == 1">{{ format(monthAvgCalData) }}</div>
                <div class="month-num" v-if="activeType == 2">{{ format(monthAvgSportStrengthData) }}</div>
                <div class="current-month" :class="{'big-month' : symbol == 0, 'step-color' : activeType == 0, 'cal-color' : activeType == 1, 'strength-color' : activeType == 2}">
                    <div class="current-month-text">{{ $t('dailyActive.monthThis') }}</div>
                </div>
                <div class="month-num" v-if="activeType == 0">{{ format(lastMonthAvgStepData) }}</div>
                <div class="month-num" v-if="activeType == 1">{{ format(lastMonthAvgCalData) }}</div>
                <div class="month-num" v-if="activeType == 2">{{ format(lastMonthAvgSportStrengthData) }}</div>
                <div class="last-month" :class="{'big-month' : symbol == 1}">
                    <div class="last-month-text">{{ $t('dailyActive.monthLast') }}</div>
                </div>
            </div>
            <div class="card-box" v-if="!showAbstract">
                <div class="no-abstract">{{ $t('dailyActive.noAbstract') }}</div>
            </div>
        </div>
        <div class="cal-prop-box" v-if="activeType === 1">
            <div class="prop-title">{{ $t('dailyActive.descTitle') }}</div>
            <div class="prop-content">
                {{ $t('dailyActive.desc') }}
            </div>
        </div>
        <div class="cal-prop-box" v-if="activeType === 2">
            <div class="prop-title">{{ $t('dailyActive.strengthTitle') }}</div>
            <div class="prop-content">
                {{ $t('dailyActive.strengthDesc') }}
            </div>
        </div>
        <div class="separate"></div>
    </div>

</template>

<script>
import {getQueryVariable, getSkin} from '@/utils/comment'
import {
    getToday,
    getNWeekFirstDay,
    getNWeekLastDay,
    getMonthStartDay,
    getMonthEndDay,
    GetDateStr, SwitchTime24,
    changeDate,
    changeMonthDate,
    GetYear
} from "../../utils/dateUtils";
import {format} from '@/utils/math'
import {dailyDataNew, getMonthDailyData, updateTarget} from "../../api/status";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'dailyActive',
    data() {
        return {
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            activeType: 0,
            activeTime: 3,
            timeUnit: '',
            time: '',
            startDate: '',
            endDate: '',
            tNum: 0,
            wNum: 0,
            mNum: 0,
            yNum: 0,
            mathData: {},
            chartData: {
                date: [],
                value: []
            },
            showTimeBox: false,
            ratio: 1,
            myChart: null, // 柱状图
            ratioChart: null, // 饼图
            showLeftOpacity: 0,
            showRightOpacity: 1,
            targetImgLeft: 0,
            showDay: false,
            foodCalories: [{
                zh: '冬瓜',
                en: 'winter melon',
                ja: '冬瓜',
                cal: '10'
            }, {
                zh: '丝瓜',
                en: 'sponge gourd',
                ja: 'ヘチマ',
                cal: '20'
            }, {
                zh: '杨梅',
                en: 'wax berry',
                ja: 'ヤマモモ',
                cal: '30'
            }, {
                zh: '梨',
                en: 'pear',
                ja: '梨',
                cal: '40'
            }, {
                zh: '苹果',
                en: 'apple',
                ja: 'リンゴ',
                cal: '50'
            }, {
                zh: '猕猴桃',
                en: 'kiwifruit',
                ja: 'キウイ',
                cal: '60'
            }, {
                zh: '荔枝',
                en: 'lychee',
                ja: 'ライチ',
                cal: '70'
            }, {
                zh: '螃蟹',
                en: 'crab',
                ja: 'カニ匹',
                cal: '80'
            }, {
                zh: '香蕉',
                en: 'banana',
                ja: 'バナナ',
                cal: '90'
            }, {
                zh: '凉皮',
                en: 'Cold Skin Noodles',
                ja: '凉皮',
                cal: '100'
            }, {
                zh: '猪肚',
                en: 'Pig\'s Stomach',
                ja: '豚の胃袋',
                cal: '110'
            }, {
                zh: '鸡腿',
                en: 'Chicken Leg',
                ja: '鶏の足',
                cal: '120'
            }, {
                zh: '紫薯',
                en: 'Purple Sweet Potato',
                ja: '紫いも',
                cal: '130'
            }, {
                zh: '青菜包',
                en: 'Green Vegetable Bun',
                ja: '野菜包み',
                cal: 140
            }, {
                zh: '榴莲',
                en: 'Durian',
                ja: 'ドリアン',
                cal: 150
            }, {
                zh: '鹌鹑蛋',
                en: 'Quail Egg',
                ja: 'うずらの卵',
                cal: 160
            }, {
                zh: '窝窝头',
                en: 'Wotou',
                ja: '窝窝头',
                cal: 170
            }, {
                zh: '鸭蛋',
                en: 'Duck Egg',
                ja: 'アヒルの卵',
                cal: 180
            }, {
                zh: '糯米鸡',
                en: 'Sticky Rice Chicken',
                ja: 'もち米鶏',
                cal: 190
            }, {
                zh: '炒面',
                en: 'Fried Noodles',
                ja: '焼きそば',
                cal: 200
            }, {
                zh: '烧卖',
                en: 'Siu Mai',
                ja: 'シュウマイ',
                cal: 210
            }, {
                zh: '馒头',
                en: 'Steamed Bun',
                ja: 'マントー',
                cal: 220
            }, {
                zh: '馄饨',
                en: 'Wonton',
                ja: 'ワンタン',
                cal: 230
            }, {
                zh: '小笼包',
                en: 'Soup Dumpling',
                ja: 'ショーロンポー',
                cal: 240
            }, {
                zh: '全麦面包',
                en: 'Whole Wheat Bread',
                ja: '全粒粉パン',
                cal: 250
            }, {
                zh: '烧饼',
                en: 'Chinese Sesame',
                ja: '焼餅',
                cal: 260
            }, {
                zh: '螺蛳粉',
                en: 'Luosifen',
                ja: '螺蛳粉',
                cal: 270
            }, {
                zh: '红肠',
                en: 'Red Sausage',
                ja: 'ソーセージ本',
                cal: 280
            }, {
                zh: '猪小排',
                en: 'Pork Spare Ribs',
                ja: '豚のステーキ',
                cal: 290
            }, {
                zh: '锅盔',
                en: 'Guokui',
                ja: 'Guokui',
                cal: 300
            }, {
                zh: '汤圆',
                en: 'Tangyuan',
                ja: 'Tangyuan',
                cal: 310
            }, {
                zh: '果丹皮',
                en: 'Guodanpi',
                ja: 'Guodanpi',
                cal: 320
            }, {
                zh: '牛腩',
                en: 'Beef Brisket',
                ja: 'サーロイン',
                cal: 330
            }, {
                zh: '葡萄干',
                en: 'Raisin',
                ja: 'レーズン',
                cal: 340
            }, {
                zh: '五花肉',
                en: 'Pork Belly',
                ja: 'ストリーキーポーク',
                cal: 350
            }],
            userData: {}, // 身高体重步幅,
            targetData: '', // 目标数据
            currentData: 0, // 当前数据
            completRate: 0, // 完成率
            stepDistance: 0, // 步数距离
            stepLaps: 0, // 步数圈数
            stepCal: 0, // 步数卡路里
            bigFood: {
                zh: '五花肉',
                en: 'Pork Belly',
                ja: 'ストリーキーポーク',
                cal: 350,
                num: 1
            },
            smallFood: {},
            showAnd: false,
            targetDay: '', // 达标天数
            allDay: '', // 总天数
            monthAvgStepData: '', // 本月每日平均
            lastMonthAvgStepData: '', // 上月每日平均
            monthAvgCalData: '', // 本月每日平均
            lastMonthAvgCalData: '', // 上月每日平均
            monthAvgSportStrengthData: '', // 本月每日平均
            lastMonthAvgSportStrengthData: '', // 上月每日平均
            symbol: '', // 0-多， 1- 少, 2-持平
            chartNone: 0, // 0-有数据， 1-没数据
            showAbstract: false,
            showSportStrength: false, // 运动强度
        }
    },
    watch: {
        showTimeBox: {
            handler(newVal, olVal) {
                if (newVal) {
                    setTimeout(() => {
                        document.addEventListener('click', this.checkClick);
                    }, 0);
                } else {
                    document.removeEventListener('click', this.checkClick);
                }
            }
        }
    },
    mounted() {
        let watchType = this.$route.query.watchType;
        if (watchType && (watchType.indexOf('TA7') != -1 ||  watchType.indexOf('TA30') != -1)) {
            this.showDay = true;
        }
        if (watchType && (watchType.indexOf('TA3') != -1 ||  watchType.indexOf('TA30') != -1)) {
            this.showSportStrength = true;
            this.showDay = true;
        }
        if (this.showDay) {
            this.timeUnit = this.$t('dailyActive.time3');
            this.activeTime = 3;
            this.startDate = GetDateStr(this.tNum);
            this.endDate = GetDateStr(this.tNum);
            this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
        } else {
            this.activeTime = 0;
            this.timeUnit = this.$t('dailyActive.time0');
            this.startDate = getNWeekFirstDay(this.wNum);
            this.endDate = getNWeekLastDay(this.wNum);
            this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
        }

        this.getData();
        this.getMonthDailyData();
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        checkClick(event) {
            let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
            if (!dom.contains(event.target)) {
                // 不在菜单范围，隐藏即可
                if (this.showTimeBox) {
                    this.showTimeBox = false;
                    document.removeEventListener('click', this.checkClick);
                }
            }
        },
        checkOpacity() {
            if (this.activeTime === 3 && this.tNum <= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 0 && this.wNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 1 && this.mNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 2 && this.yNum >= 0) {
                this.showRightOpacity = 1
            } else {
                this.showRightOpacity = 0
            }
            if (this.activeTime === 3 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 2 && GetYear(this.yNum - 1) <= 2019) {
                this.showLeftOpacity = 1
            } else {
                this.showLeftOpacity = 0
            }
        },
        timeLeft() {
            if (this.activeTime == 3 && this.startDate > '2020-01-01') {
                this.tNum++;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                this.wNum--;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                this.mNum--;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            } else if (this.activeTime == 2 && GetYear(this.yNum - 1) > 2019) {
                this.yNum--;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        timeRight() {
            if (this.activeTime == 3 && this.tNum > 0) {
                this.tNum--;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 0 && this.wNum < 0) {
                this.wNum++;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.mNum < 0) {
                this.mNum++;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            } else if (this.activeTime == 2 && this.yNum < 0) {
                this.yNum++;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        changeTimeType(num, unit) {
            this.activeTime = num;
            this.timeUnit = unit;
            this.showTimeBox = false;
            if (this.activeTime == 3) {
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 0) {
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 1) {
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            if (this.activeTime == 2) {
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        changeType() {
            this.mathData = {}
            this.chartData = {
                date: [],
                value: []
            }
            this.getData();
            this.getMonthDailyData();
        },
        getData() {
            let type;
            if (this.activeType == 0) {
                type = 'step';
            } else if (this.activeType == 1) {
                type = 'calorie';
            } else if (this.activeType == 2) {
                type = 'sportStrength';
            }
            if (this.activeTime == 3) {
                this.chartData.value = [];
                this.chartData.date = ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'];
                this.$api.status.dailyDataNew({
                    date: this.startDate,
                    type: type
                }).then(res => {
                    if (res.info.dailyData != null) {
                        this.chartNone = 0
                        this.chartData.value = res.info.dailyData.split(',');
                    } else {
                        this.chartData.value = []
                        this.chartNone = 1
                    }
                    if (res.info.data != null) {
                        this.currentData = res.info.data;
                    }
                    this.userData = res.info.userData;
                    if (this.activeType == 0) {
                        this.targetData = res.info.targetData;
                        this.drawChart(getSkin('--chart-color-8'), getSkin('--chart-color-26'), 0);
                    } else if (this.activeType == 1) {
                        this.currentData = Math.round(this.currentData / 1000);
                        this.targetData = Math.round(res.info.targetData / 1000);
                        this.chartData.value = this.chartData.value.map(value => Math.round(value / 1000));
                        this.drawChart(getSkin('--chart-color-3'), getSkin('--chart-color-4'), 1);
                    } else if (this.activeType == 2) {
                        this.currentData = Math.round(this.currentData / 60);
                        this.targetData = res.info.targetData / 60;
                        this.drawChart(getSkin('--chart-color-1'), getSkin('--chart-color-2'), 2);
                    }
                    this.completRate = this.currentData / this.targetData > 1 ? 1 : this.currentData / this.targetData;
                    this.targetImgLeft = 310 * this.ratio * this.completRate - 8 * this.ratio;
                    if (type == 'step') {
                        this.stepDistance = (this.currentData * this.userData.userStep / 100000).toFixed(2);
                        this.stepLaps = (this.currentData * this.userData.userStep / 100 / 400).toFixed(2)
                        let size = this.userData.userHeight * 0.45;
                        this.stepCal = Math.round(this.currentData * size * this.userData.userWeight / 82.14 / 1000 / 10) * 10;
                        this.calCal(this.stepCal);
                    } else {
                        this.calCal(Math.round(this.currentData / 10) * 10);
                    }
                })
            } else if (this.activeTime == 2) {
                this.$api.status.getDailyDataYearNew({
                    type: type,
                    year: this.startDate,
                }).then(res => {
                    if (res.result == 1) {
                        this.mathData = {
                            maxData: res.info.queryBasicMath.max,
                            avgData: Math.round(res.info.queryBasicMath.avg),
                            sum: res.info.queryBasicMath.sum
                        };
                        this.chartData.date = [];
                        this.chartData.value = [];
                        for (let i = 0; i < res.info.data.length; i++) {
                            let date;
                            let value = res.info.data[i].value
                            date = i + 1;
                            if (this.activeType == 1) {
                                value = parseInt(value / 1000)
                            }
                            this.chartData.date.push(date);
                            this.chartData.value.push(value);
                        }
                        this.userData = res.info.userData;
                        if (this.mathData.sum > 0) {
                            this.chartNone = 0
                        } else {
                            this.chartNone = 1
                        }
                        if (this.activeType == 0) {
                            this.currentData = res.info.queryBasicMath.sum;
                            this.stepDistance = (this.currentData * this.userData.userStep / 100000).toFixed(2);
                            this.stepLaps = (this.currentData * this.userData.userStep / 100 / 400).toFixed(2)
                            let size = res.info.userData.userHeight * 0.45;
                            this.stepCal = Math.round(this.currentData * size * res.info.userData.userWeight / 82.14 / 1000 / 10) * 10;
                            this.calCal(this.stepCal);
                            this.drawChart(getSkin('--chart-color-8'), getSkin('--chart-color-26'), 0);
                        } else if (this.activeType == 1) {
                            this.calCal(Math.round(res.info.queryBasicMath.sum / 10000) * 10);
                            this.currentData = Math.round(res.info.queryBasicMath.sum / 1000);
                            this.drawChart(getSkin('--chart-color-3'), getSkin('--chart-color-4'), 1);
                        } else if (this.activeType == 2) {
                            this.drawChart(getSkin('--chart-color-1'), getSkin('--chart-color-2'), 2);
                        }

                        this.targetDay = res.info.queryBasicMath.targetDay;
                        this.allDay = res.info.queryBasicMath.allDay;
                        console.log(this.mathData.sum)
                    }
                })
            } else {
                this.$api.status.getDailyData({
                    type: type,
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.mathData = {
                            maxData: res.info.queryBasicMath.max,
                            avgData: Math.round(res.info.queryBasicMath.avg),
                            sum: res.info.queryBasicMath.sum
                        };
                        this.chartData.date = [];
                        this.chartData.value = [];
                        for (let i = 0; i < res.info.data.length; i++) {
                            let date;
                            let value = res.info.data[i].value
                            date = changeDate(res.info.data[i].date)
                            if (this.activeType == 1) {
                                value = parseInt(value / 1000)
                            }
                            this.chartData.date.push(date);
                            this.chartData.value.push(value);
                        }
                        this.userData = res.info.userData;
                        if (this.mathData.sum > 0) {
                            this.chartNone = 0
                        } else {
                            this.chartNone = 1
                        }
                        if (this.activeType == 0) {
                            this.currentData = res.info.queryBasicMath.sum;
                            this.stepDistance = (this.currentData * this.userData.userStep / 100000).toFixed(2);
                            this.stepLaps = (this.currentData * this.userData.userStep / 100 / 400).toFixed(2)
                            let size = res.info.userData.userHeight * 0.45;
                            this.stepCal = Math.round(this.currentData * size * res.info.userData.userWeight / 82.14 / 1000 / 10) * 10;
                            this.calCal(this.stepCal);
                            this.drawChart(getSkin('--chart-color-8'), getSkin('--chart-color-26'), 0);
                        } else if (this.activeType == 1) {
                            this.calCal(Math.round(res.info.queryBasicMath.sum / 10000) * 10);
                            this.currentData = Math.round(res.info.queryBasicMath.sum / 1000);
                            this.drawChart(getSkin('--chart-color-3'), getSkin('--chart-color-4'), 1);
                        } else if (this.activeType == 2) {
                            this.drawChart(getSkin('--chart-color-1'), getSkin('--chart-color-2'), 2);
                        }
                        this.targetDay = res.info.queryBasicMath.targetDay;
                        this.allDay = res.info.queryBasicMath.allDay;
                        console.log(this.mathData.sum)
                    }
                })
            }
        },
        drawChart(color1, color2, tag) {
            if (!this.myChart) {
                this.myChart = this.$echarts.init(document.getElementById("chart-box"));
            }
            let barWidth = 10 * this.ratio;
            if (this.activeTime == 1 || this.activeTime == 3) {
                barWidth = 4 * this.ratio;
            } else {
                barWidth = 10 * this.ratio;
            }
            let interval = 0;
            if (this.activeTime == 3) {
                interval = 10;
            } else if (this.activeTime == 1){
                interval = 6;
            }
            let _this = this;
            if (this.chartNone == 1) {
                this.myChart.setOption({
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 76 * this.ratio,
                        textStyle: {
                            fontFamily: 'SF',
                            fontSize: 12 * this.ratio,
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 20 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio,
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: interval
                        },
                        data: this.chartData.date
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        boundaryGap: [0, '10%'],
                        axisLabel: false,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        }
                    },
                    series: [
                        {
                            data: this.chartData.value,
                            type: 'bar',
                            symbol: 'none',
                            smooth: false,
                            barWidth: barWidth,
                            itemStyle: {
                                color: color1,
                                borderRadius: [5, 5, 0, 0],
                            },
                            emphasis: {
                                itemStyle: {
                                    color: color2,
                                    borderRadius: [5, 5, 0, 0],
                                },
                            },
                            lineStyle: {
                                width: 3
                            }
                        }
                    ]
                }, true);
            } else {
                this.myChart.setOption({
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio,
                    },
                    xAxis: {
                        type: 'category',
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            interval: interval
                        },
                        data: this.chartData.date
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        boundaryGap: [0, '10%'],
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            fontFamily: "'D-D','SF'",
                            formatter: function (value) {
                                if (tag !== 2) {
                                    if (value >= 1000) {
                                        value = value / 1000
                                        if (/^\d+$/.test(value)) {
                                            return value + 'k';
                                        } else {
                                            return value.toFixed(1) + 'k';
                                        }
                                    } else if (value >= 1000000) {
                                        value = value / 1000000
                                        if (/^\d+$/.test(value)) {
                                            return value + 'M';
                                        } else {
                                            return value.toFixed(1) + 'M';
                                        }
                                    } else {
                                        return value
                                    }
                                } else {
                                    return (value / 60).toFixed(1)
                                }

                            },
                            showMinLabel: false
                        },
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        }
                    },
                    tooltip: {
                        textStyle: {
                            fontFamily: "'D-D','SF'",
                        },
                        backgroundColor: getSkin('--bg-color-2'),
                        trigger: 'axis',
                        axisPointer: {
                            type: 'line'
                        },
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = format(item.data);
                            if (tag == 2) {
                                value = value.split(',').join('');
                                const minutes = Math.floor(value / 60);
                                const seconds = Math.floor(value % 60);

                                // 当秒数为0时只显示分钟
                                if (minutes === 0) {
                                    value = `${seconds} s`;
                                } else if (seconds === 0){
                                    value = `${minutes} min`;
                                } else {
                                    value = `${minutes} min ${seconds} s`;
                                }
                            }
                            if (item.data == 0) {
                                return
                            }
                            let unit;
                            if (tag === 0) {
                                unit = _this.$t('dailyActive.unit0');
                            } else if (tag === 1) {
                                unit = _this.$t('dailyActive.unit1');
                            } else if (tag === 2) {
                                unit = '';
                            }
                            let html = '';
                            let arrIndex = item.axisValue - 1;
                            let monthArr = _this.$t('monthArr');
                            let month;
                            if (_this.activeTime == 2) {
                                month = monthArr[arrIndex];
                            } else if (_this.activeTime == 3) {
                                if (item.dataIndex == 47) {
                                    month = _this.chartData.date[item.dataIndex] + ' ~ 00:00';
                                } else {
                                    month = _this.chartData.date[item.dataIndex] + ' ~ ' + _this.chartData.date[item.dataIndex + 1];
                                }
                            } else {
                                month = item.axisValue;
                            }
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '">' + month + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span> ' + unit + '</div>'
                            return html
                        }
                    },
                    series: [
                        {
                            data: this.chartData.value,
                            type: 'bar',
                            symbol: 'none',
                            smooth: false,
                            barWidth: barWidth,
                            itemStyle: {
                                color: color1,
                                borderRadius: [5, 5, 0, 0],
                            },
                            emphasis: {
                                itemStyle: {
                                    color: color2,
                                    borderRadius: [5, 5, 0, 0],
                                },
                            },
                        }
                    ]
                }, true);
            }
        },
        format(num) {
            return format(num)
        },
        toAbstract() {
            this.$router.push({
                name: 'abstract',
                query: {
                    type: this.activeType,
                    userStep: this.userData.userStep,
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        calStep() {

        },
        calCal(cal) {
            console.log(cal)
            let receiveCal = cal % 350;
            this.bigFood.num = (cal - receiveCal) / 350;
            console.log('receiveCal', receiveCal)
            console.log('bigFood', this.bigFood)
            if (receiveCal > 0) {
                this.smallFood = this.foodCalories.find(food => food.cal == receiveCal);
            } else {
                this.smallFood = 0
            }
            if (cal > 350 && receiveCal > 0) {
                this.showAnd = true
            } else {
                this.showAnd = false
            }
        },
        getMonthDailyData() {
            let type;
            if (this.activeType == 0) {
                type = 'step';
            } else if (this.activeType == 1) {
                type = 'calorie';
            } else if (this.activeType == 2) {
                type = 'sportStrength';
            }
            this.$api.status.getMonthDailyData({
                type
            }).then(res => {
                if (this.activeType == 0) {
                    this.lastMonthAvgStepData = Math.round(res.info.lastMonthAvgData)
                    this.monthAvgStepData = Math.round(res.info.monthAvgData)
                } else if (this.activeType == 1) {
                    this.lastMonthAvgCalData = Math.round(res.info.lastMonthAvgData / 1000)
                    this.monthAvgCalData = Math.round(res.info.monthAvgData / 1000)
                } else if (this.activeType == 2) {
                    this.lastMonthAvgSportStrengthData = Math.round(res.info.lastMonthAvgData/60)
                    this.monthAvgSportStrengthData = Math.round(res.info.monthAvgData/60)
                }

                if (res.info.lastMonthAvgData == 0 && res.info.monthAvgData == 0) {
                    this.showAbstract = false
                } else {
                    this.showAbstract = true
                }

                if (res.info.lastMonthAvgData > res.info.monthAvgData) {
                    this.symbol = 1
                } else if (res.info.lastMonthAvgData < res.info.monthAvgData) {
                    this.symbol = 0
                } else {
                    this.symbol = 2
                }
                console.log(this.monthAvgSportStrengthData)
            })
        },
        toActiveTarget() {
            this.$router.push({
                name: 'activeTarget',
                query: {
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        }
    },
    unmounted() {
        document.removeEventListener('click', this.checkClick);
    }
}
</script>

<style scoped>

/deep/ .van-tab {
    font-size: 15px;
    letter-spacing: 1.5px;
}

#chart-box {
    height: 198px;
    width: 100%;
    letter-spacing: 0;
}

.chart-unit {
    position: absolute;
    font-size: 11px;
    color: var(--text-color-3);
    left: 15px;
    top: 18px;
    line-height: 12px;
}

.chart-unit-cal {
    position: absolute;
    font-size: 11px;
    color: var(--text-color-3);
    left: 10px;
    top: 18px;
    line-height: 22px;
}

.math-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto 10px;
    height: auto;
}

.math-item {
    text-align: left;
    margin-top: 15px;
}

.math-num {
    font-size: 24px;
    line-height: 32px;
    color: var(--text-color-1);
    margin-left: 19px;
    letter-spacing: 0.5px;
}

.math-text {
    font-size: 13px;
    color: var(--text-color-1);
    margin-left: 19px;
}

.cal-prop-box {
    margin: 0 auto;
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
}

.prop-title {
    font-size: 15px;
    color: var(--text-color-1);
    margin: 0px 15px 12px 16px;
    padding-top: 17px;
}

.prop-content {
    font-size: 13px;
    margin: 0 15px 0px 16px;
    color: var(--text-color-2);
    padding-bottom: 16px;
    line-height: 18px;
}

.card {
    margin-bottom: 10px;
    width: 100%;
}

.card-title {
    color: var(--text-color-3);
    font-size: 15px;
    float: left;
    line-height: 17px;
    margin-left: 15px;
    letter-spacing: 2px;
}

.target-set {
    font-size: 13px;
    color: var(--text-color-1);
    float: right;
    margin-right: 15px;
    display: flex;
    letter-spacing: 2px;
    align-items: center;
}

.to-img {
    width: 16px;
    margin-left: 3px;
    align-items: center;
}

.card-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto;
}

.card-title-line {
    height: 26px;
    width: 100%;
    margin-top: 20px;
}

.current-step {
    font-size: 24px;
    color: var(--text-color-1);
    margin-left: 18px;
}

.target-step {
    font-size: 15px;
    color: var(--text-color-3);
}

.percent {
    width: 310px;
    text-align: center;
    position: relative;
    margin-left: 18px;
}

/deep/ .van-progress__pivot {
    display: none !important;
}

.percent-img {
    width: 16px;
    position: absolute;
    top: -3px;
}

.target-desc {
    font-size: 13px;
    color: var(--text-color-2);
    margin: 12px 18px;
    letter-spacing: 0.5px;
    line-height: 18px;
}

.ratio-title {
    font-size: 12px;
    border-radius: 5px 5px 5px 5px;
    margin-left: 10px;
    text-align: center;
    letter-spacing: 2px;
    padding: 4px 6px;
    line-height: 12px;
    display: table;
}

.ratio-title-step {
    color: var(--chart-color-8);
    border: 1px solid var(--chart-color-8);
}

.ratio-title-cal {
    color: var(--chart-color-3);
    border: 1px solid var(--chart-color-3);
}

 .ratio-title-strength {
    color: var(--chart-color-1);
     border: 1px solid var(--chart-color-1);
}

.separate {
    height: 15px;
}

.current-month {
    width: 238px;
    height: 18px;
    border-radius: 9px 9px 9px 9px;
    margin-left: 16px;
    letter-spacing: 2px;
}

.step-color {
    background: var(--chart-color-8);
}

.cal-color {
    background: var(--chart-color-3);
}

.strength-color {
    background-color: var(--chart-color-1);
}

.big-month {
    width: 307px !important;
}

.month-num {
    font-size: 16px;
    color: var(--text-color-1);
    margin-left: 16px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.last-month {
    width: 238px;
    height: 18px;
    background: #9DACB7;
    border-radius: 9px 9px 9px 9px;
    margin-left: 16px;
    letter-spacing: 2px;
}

.current-month-text {
    font-size: 13px;
    color: #ffffff;
    line-height: 18px;
    margin-left: 7px;
}

.last-month-text {
    font-size: 13px;
    color: #000000;
    margin-left: 7px;
    line-height: 18px;
}

.reach-progress {
    width: 200px;
    margin-left: 16px;
    position: relative;
    display: inline-block;
}

/deep/ .van-progress {
    border-radius: 20px;
}

.reach-text {
    position: absolute;
    left: 0px;
    top: 0px;
}

.reach-num-text {
    font-size: 24px;
    color: var(--text-color-1);
}

.reach-num {
    font-size: 16px;
    color: var(--text-color-3);
    width: 100px;
    display: inline-block;
    margin-left: 20px;
    margin-bottom: 10px;
}

.target-title {
    font-size: 17px;
    color: var(--text-color-1);
    text-align: center;
    padding-top: 20px;
}

/deep/ .van-picker__toolbar {
    height: 57px;
}

/deep/ .van-picker__title {
    color: var(--text-color-1);
    font-size: 17px;
}

/deep/ .van-picker__confirm {
    color: var(--chart-color-8);
    font-size: 17px;
}

/deep/ .van-picker__cancel {
    font-size: 17px;
    color: var(--text-color-2);
}

.target-line {
    line-height: 48px;
}

.reach-line {
    display: flex;
    align-items: center;
    margin-top: 14px;
    height: 28px;
}

.compare-box {
    width: 315px;
    background: var(--bg-color-1);
    border-radius: 13px 13px 13px 13px;
    margin: 0px auto 0;
    position: relative;
}

.compare-title-distance {
    font-size: 13px;
    color: var(--chart-color-8);
    position: absolute;
    top: 12px;
    left: 18px;
    letter-spacing: 2px;
}

.compare-title-cal {
    font-size: 13px;
    color: var(--chart-color-3);
    position: absolute;
    top: 12px;
    left: 186px;
    letter-spacing: 2px;
}

.compare-desc-box {
    width: 279px;
    padding-top: 59px;
    margin: 0 auto;
    min-height: 13px;
    font-size: 13px;
    color: var(--text-color-2);
    padding-bottom: 14px;
    letter-spacing: 0.5px;
    line-height: 18px;
}

.compare-distance-line {
    font-size: 13px;
    color: var(--text-color-3);
    position: absolute;
    left: 18px;
    top: 28px;
}

.compare-cal-line {
    font-size: 12px;
    color: var(--text-color-3);
    position: absolute;
    left: 186px;
    top: 28px;
}

.compare-num {
    font-size: 20px;
    color: var(--text-color-1);
    margin-right: 3px;
}

.reach-card-box {
    width: 345px;
    height: 75px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 10px auto;
    position: relative;
}

.reach-img {
    width: 16px;
    position: absolute;
    left: 18px;
    top: 17px;
}

.reach-card-text {
    font-size: 16px;
    color: var(--text-color-1);
    position: absolute;
    left: 38px;
    top: 18px;
    line-height: 16px;
}

.reach-card-line {
    position: absolute;
    top: 23px;
}

.no-abstract {
    font-size: 12px;
    color: var(--text-color-3);
    text-align: center;
    line-height: 50px;
}

/deep/ .van-tabs__nav {
    background-color: var(--bg-color-1);
}

/deep/ .van-tabs--line .van-tabs__wrap {
    height: auto;
}

/deep/ .van-tabs__line {
    bottom: 10px;
    width: 20px;
}

.daily-avg {
    padding: 16px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/status/01dailyActive.vue